const style = {
    pageBorder: {
        padding: "20px",
        marginBottom: "20px"
    }
}

export default style;